$(window).on('load', function () {
  //     "use strict";

  $('ul.navbar-nav > li.dropdown').hover(function() {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeIn(500);
  }, function() {
    $(this).find('.dropdown-menu').stop(true, true).delay(200).fadeOut(500);
  });

  $('.support-block .support-block-contact').hover(function() {
    $(this).find('.support-block-contact-list').stop(true, true).delay(50).fadeIn(250);
  }, function() {
    $(this).find('.support-block-contact-list').stop(true, true).delay(50).fadeOut(250);
  });

  // $('.accordion > li:eq(0) a').addClass('active').next().slideDown();

  //   $('.accordion a').click(function(j) {
  //       var dropDown = $(this).closest('li').find('p');

  //       $(this).closest('.accordion').find('p').not(dropDown).slideUp();

  //       if ($(this).hasClass('active')) {
  //           $(this).removeClass('active');
  //       } else {
  //           $(this).closest('.accordion').find('a.active').removeClass('active');
  //           $(this).addClass('active');
  //       }

  //       dropDown.stop(false, true).slideToggle();

  //       j.preventDefault();
  //   });
  
  
  /* =============== Ajax Contact Form ===================== */
  $('#contactform').submit(function () {
    var action = $(this).attr('action');
    $("#message").slideUp(750, function () {
      $('#message').hide();
      $('#submit')
        .after('<img src="images/ajax-loader.gif" class="loader" />')
        .attr('disabled', 'disabled');
      $.post(action, {
          name: $('#name').val(),
          email: $('#email').val(),
          comments: $('#comments').val(),
          verify: $('#verify').val()
        },
        function (data) {
          document.getElementById('message').innerHTML = data;
          $('#message').slideDown('slow');
          $('#contactform img.loader').fadeOut('slow', function () {
            $(this).remove()
          });
          $('#submit').removeAttr('disabled');
          if (data.match('success') != null) $('#contactform').slideUp('slow');

        }
      );
    });
    return false;
  });

  $('.js-btn').eq(0).click(() => {
    $('html, body').animate({
      scrollTop: $('.js-section').eq(0).offset().top
    }, 300);
  });

  $('.js-btn').eq(1).click(() => {
    $('html, body').animate({
      scrollTop: $('.js-section').eq(1).offset().top
    }, 300);
  });

  $('.js-btn').eq(2).click(() => {
    $('html, body').animate({
      scrollTop: $('.js-section').eq(2).offset().top
    }, 300);
  });

  $('.js-btn').eq(3).click(() => {
    $('html, body').animate({
      scrollTop: $('.js-section').eq(3).offset().top
    }, 300);
  });


  /*** FIXED Menu APPEARS ON SCROLL DOWN ***/
  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 50) {
      $(".forsticky").addClass("sticky");
    } else {
      $(".forsticky").removeClass("sticky");
      $(".forsticky").addClass("");
    }
  });

  /* Skip Loading */
  $('.page-loading > span').on('click', function () {
    $(this).parent().fadeOut();
  });

  /* Signin Popup 
  $('.signin-popup').on('click', function () {
    $('.signin-popup-box').fadeIn('fast');
    $('html').addClass('no-scroll');
  });
  $('.close-popup').on('click', function () {
    $('.signin-popup-box').fadeOut('fast');
    $('html').removeClass('no-scroll');
  });

  /* Signup Popup 
  $('.signup-popup').on('click', function () {
    $('.signup-popup-box').fadeIn('fast');
    $('html').addClass('no-scroll');
  });
  $('.close-popup').on('click', function () {
    $('.signup-popup-box').fadeOut('fast');
    $('html').removeClass('no-scroll');
  });

  /*** QUICK POST SHARE ***/
  $('.select-user > span').on('click', function () {
    $('.select-user > span').removeClass('active');
    $(this).addClass('active');
  });

  /* Tabs Sec */
  $('.tab-sec li a').on("click", function () {
    var tab_id = $(this).attr('data-tab');
    $('.tab-sec li a').removeClass('current');
    $('.tab-content').removeClass('current');
    $(this).addClass('current');
    $("#" + tab_id).addClass('current');
  });


  $('#toggle-widget .content').hide();
  $('#toggle-widget h2:first').addClass('active').next().slideDown('fast');
  $('#toggle-widget h2').on("click", function () {
    if ($(this).next().is(':hidden')) {
      $('#toggle-widget h2').removeClass('active').next().slideUp('fast');
      $(this).toggleClass('active').next().slideDown('fast');
    }
  });

  $('.sb-title.open').next().slideDown();
  $('.sb-title.closed').next().slideUp();
  // $('.sb-title').on('click', function(){
  //     $(this).next().slideToggle();
  //     $(this).toggleClass('active');
  //     $(this).toggleClass('closed');
  // });


  // $('.btns-profiles-sec').on('mouseenter', function () {
  //   $(this).find('ul').stop(true, true).fadeIn(200);
  // });
  
  // $('.btns-profiles-sec').on('mouseleave', function () {
  //   $(this).find('ul').stop(true, true).fadeOut(200);
  // });

  $('.btns-profiles-sec > ul li a').on('click', function () {
    $('.btns-profiles-sec > ul').fadeToggle();
  })
  $('[data-toggle="tooltip"]').tooltip()
  $('body').on('click', function (eve) {

    if ($(eve.target.offsetParent).hasClass('btns-profiles-sec')) {
      $('.btns-profiles-sec > ul').fadeToggle();
    } else if ($(eve.target.offsetParent).hasClass('action-center')) {
      $('.action-center ul').fadeOut()
      $('.emply-resume-list').removeClass('active')
      $(this).next('ul').fadeToggle();
      $(this).parent().parent().parent().addClass('active');
    } 
    // else if ($(eve.target.offsetParent).hasClass('open-letter')) {
    //   $('.coverletter-popup').fadeIn();
    //   $('html').addClass('no-scroll');
    // } else if ($(eve.target.offsetParent).hasClass('close-letter')) {
    //   $('.coverletter-popup').fadeOut();
    //   $('html').removeClass('no-scroll');
    // } else if ($(eve.target.offsetParent).hasClass('open-contact')) {
    //   $('.contactus-popup').fadeIn();
    //   $('html').addClass('no-scroll');
    // } else if ($(eve.target.offsetParent).hasClass('close-contact')) {
    //   $('.contactus-popup').fadeOut();
    //   $('html').removeClass('no-scroll');
    // } 
    else if ($(eve.target.offsetParent).hasClass('my-profiles-sec')) {
      $('.profile-sidebar').addClass('active');
    } else if ($(eve.target.offsetParent).hasClass('close-profile')) {
      $('.profile-sidebar').removeClass('active');
    } else if ($(eve.target.offsetParent).hasClass('wishlist-dropsec')) {
      $('.wishlist-dropdown').fadeToggle();
    } else if ($(eve.target.offsetParent).hasClass('view-resume-list')) {
      $('.view-resumesec').fadeIn();
      $('html').addClass('no-scroll');
      return false;
    } else if ($(eve.target.offsetParent).hasClass('close-resume-popup')) {
      $('.view-resumesec').fadeOut();
      $('html').removeClass('no-scroll');
    } else if ($(eve.target.offsetParent).hasClass('follow-companies-popup')) {
      $('.follow-companiesec').fadeIn();
      $('html').addClass('no-scroll');
      return false;
    } else if ($(eve.target.offsetParent).hasClass('close-follow-company')) {
      $('.follow-companiesec').fadeOut();
      $('html').removeClass('no-scroll');
    } else if ($(eve.target.offsetParent).hasClass('faq-box')) {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    } else if ($(eve.target.offsetParent).hasClass('emlthis')) {
      $(this).toggleClass('active');
      $(this).next().slideToggle();
    } else if ($(eve.target.offsetParent).hasClass('tags-bar')) {
      $(this).toggleClass('active');
    } else if ($(eve.target.offsetParent).hasClass('upload-img-bar')) {
      $(this).parent().parent().fadeOut();
    } else if ($(eve.target.offsetParent).hasClass('del-resume')) {
      $(this).parent().fadeOut();
      return false;
    } else if ($(eve.target.offsetParent).hasClass('cand-extralink')) {
      $('.cand-extralink li').removeClass('active');
      $(this).addClass('active');
    } else if ($(eve.target.offsetParent).hasClass('scrollup') || $(eve.target).hasClass('scrollup')) {
      eve.preventDefault();
      $('html, body').animate({
        scrollTop: 0
      }, 500, 'linear');
    } else if ($(eve.target.offsetParent ? (eve.target.offsetParent.parentElement) : false ).hasClass('cand-extralink')) {
      eve.preventDefault();
      var headerLength;
      if($(".cand-extralink").hasClass("stick")){
        headerLength = 140;
      } else {
        headerLength = 290;
      }
      var scrollTopEle = $($(eve.target).attr('href')).offset().top - headerLength;
      $('html, body').animate({
        scrollTop: scrollTopEle
      }, 500, 'linear');
    } else if ($(eve.target).hasClass('sb-title')) {
      $(eve.target).next().slideToggle();
      $(eve.target).toggleClass('active');
      $(eve.target).toggleClass('closed');
    } else {
      $('.action-center ul').fadeOut();
      $('.btns-profiles-sec > ul').fadeOut();
    }

    $('.tree_widget-sec > ul > li.inner-child:first > ul').slideDown();
    $('.tree_widget-sec > ul > li.inner-child:first').addClass('active');
    $('.tree_widget-sec > ul > li.inner-child > a').on('click', function () {
      $('.tree_widget-sec > ul > li.inner-child').removeClass('active');
      $('.tree_widget-sec > ul > li > ul').slideUp();
      $(this).parent().addClass('active');
      $(this).next('ul').slideDown();
      return false;
    });

    
			$('.datepicker').datepicker({
			    format: 'mm-dd-yyyy'
			});
		

  });

  // $('body').on('click', function(){
  //     $('.btns-profiles-sec > ul').fadeOut();
  // });

  $(".btns-profiles-sec").on("click", function (e) {
    e.stopPropagation();
  });

  // $('.action-center > span').on('click', function(){
  //     $('.action-center ul').fadeOut()
  //     $('.emply-resume-list').removeClass('active')
  //     $(this).next('ul').fadeToggle();
  //     $(this).parent().parent().parent().addClass('active');
  // });
  // $('body').on('click', function(){
  //     $('.action-center ul').fadeOut();
  // });
  // $(".action-center").on("click",function(e){
  //     e.stopPropagation();
  // });

  // $('.open-letter').on('click', function(){
  //     $('.coverletter-popup').fadeIn();
  //     $('html').addClass('no-scroll');
  // });
  // $('.close-letter').on('click', function(){
  //     $('.coverletter-popup').fadeOut();
  //     $('html').removeClass('no-scroll');
  // });

  // $('.open-contact').on('click', function(){
  //     $('.contactus-popup').fadeIn();
  //     $('html').addClass('no-scroll');
  // });
  // $('.close-contact').on('click', function(){
  //     $('.contactus-popup').fadeOut();
  //     $('html').removeClass('no-scroll');
  // });

  // $('.my-profiles-sec > span').on('click', function(){
  //     $('.profile-sidebar').addClass('active');
  // });
  // $('.close-profile').on('click', function(){
  //     $('.profile-sidebar').removeClass('active');
  // });

  // $('.wishlist-dropsec > span').on('click', function(){
  //     $('.wishlist-dropdown').fadeToggle();
  // });
  // // $('body').on('click', function(){
  // //     $('.wishlist-dropdown').fadeOut();
  // // });
  // $(".wishlist-dropsec").on("click",function(e){
  //     e.stopPropagation();
  // });

  // $('.view-resume-list').on('click', function(){
  //     $('.view-resumesec').fadeIn();
  //     $('html').addClass('no-scroll');
  //     return false;
  // });
  // $('.close-resume-popup').on('click', function(){
  //     $('.view-resumesec').fadeOut();
  //     $('html').removeClass('no-scroll');
  // });

  // $('.follow-companies-popup').on('click', function(){
  //     $('.follow-companiesec').fadeIn();
  //     $('html').addClass('no-scroll');
  //     return false;
  // });
  // $('.close-follow-company').on('click', function(){
  //     $('.follow-companiesec').fadeOut();
  //     $('html').removeClass('no-scroll');
  // });

  // $('.faq-box > h2').on('click', function(){
  //     $(this).toggleClass('active');
  //     $(this).next().slideToggle();
  // });

  $('.scroll-to a, .back-top, .cand-extralink a').on('click', function (e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: $($(this).attr('href')).offset().top
    }, 500, 'linear');
  });

  // $('.scrollup').on('click', function(e) {
  //     e.preventDefault();
  //     $('html, body').animate({ scrollTop: 0}, 500, 'linear');
  // });

  // $('.fav-job').on('click', function(){
  //     $(this).toggleClass('active');
  // });

  // $('.emlthis').on('click', function(){
  //     $(this).toggleClass('active');
  // });

  // $('.tags-bar > span i').on('click', function(){
  //     $(this).parent().fadeOut();
  // });

  // $('.upload-img-bar > span i').on('click', function(){
  //     $(this).parent().parent().fadeOut();
  // });

  // $('.del-resume').on('click', function(){
  //     $(this).parent().fadeOut();
  //     return false;
  // });

  // $('.cand-extralink li').on('click', function(){
  // 	$('.cand-extralink li').removeClass('active');
  // 	$(this).addClass('active');
  // });
  /*** FIXED Menu APPEARS ON SCROLL DOWN ***/
  $(window).on('scroll', function () {
    var scroll = $(window).scrollTop();
    if (scroll >= 500) {
      $(".cand-extralink").addClass("stick");
    } else {
      $(".cand-extralink").removeClass("stick");
      $(".cand-extralink").addClass("");
    }
  });

  $(".responsivemenu .menu-item-has-children > a").on("click", function () {
    $(this).parent().siblings().children("ul").slideUp();
    $(this).parent().siblings().removeClass("active");
    $(this).parent().children("ul").slideToggle();
    $(this).parent().toggleClass("active");
    return false;
  });

  // $('.res-openmenu').on('click', function () {
  //   $('.responsive-header').addClass('active');
  //   $('.responsive-opensec').slideDown();
  //   $('.res-closemenu').removeClass('active')
  //   $(this).addClass('active');
  // });

  // $('.res-closemenu').on('click', function () {
  //   $('.responsive-header').removeClass('active');
  //   $('.responsive-opensec').slideUp();
  //   $('.res-openmenu').removeClass('active')
  //   $(this).addClass('active');
  // });
  // $('.responsive-opensec .account-btns li  a').on('click', function () {
  //   $('.responsive-header').removeClass('active');
  //   $('.responsive-opensec').slideUp();
  //   $('.res-openmenu').removeClass('active')
  //   $(this).addClass('active');
  // });

  /* Table Scroll */
  $('.manage-jobs-sec > table').parent().addClass('addscroll')
  $(".slider").slick({


  });
});
$(window).scroll(function(){
  const isHamburgerOpen = $('body').hasClass('hamburger-open');

  if (isHamburgerOpen) {
    return; // If hamburger is open, do nothing!
  }
  if ($(window).scrollTop() >= 150) {
    const headerSize = $('#headerContent').height();
    $('#headerContent').css('height',headerSize);
     $('#desktop-nav').addClass('fixed');
     $('#desktop-nav').addClass('animated fadeInDown faster');
   }
   else {
    $('#headerContent').attr('style','');
    $('#desktop-nav').removeClass('fixed');
    $('#desktop-nav').removeClass('animated fadeInDown faster');
   }
});
$(window).on('load', function () {
  "use strict";

  $('.page-loading').fadeOut();

});
// (function () {
//   var previousScroll = 0;

//   $(window).scroll(function(){
//      var currentScroll = $(this).scrollTop();
//      if (currentScroll > previousScroll){
//       $('#headerContent').attr('style','');
//       $('#desktop-nav').removeClass('fixed');
//       $('#desktop-nav').removeClass('animated fadeInDown faster');
//      } else {
//       const headerSize = $('#headerContent').height();
//       $('#headerContent').css('height',headerSize);
//        $('#desktop-nav').addClass('fixed');
//        $('#desktop-nav').addClass('animated fadeInDown faster');
//      }
//      previousScroll = currentScroll;
//   });
// }()); //run this anonymous function immediately